module.exports = __webpack_public_path__ + "img/chinesecompany47.469f6ac7.png";